import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./components/Home";
import { Col, Container, Nav, Navbar, NavDropdown, Row, Spinner } from "react-bootstrap";


import EstructuraOperativa from "./components/incidentes/EstructuraInterna/EstructuraOperativa";
import OrganigramaOperacional from "./components/incidentes/EstructuraInterna/OrganigramaOperacional";


import ProcesoCompleto from "./components/incidentes/ProcesoComercialIT/ProcesoCompleto";
import ProcesoCompletoIT from "./components/incidentes/ProcesoComercialIT/ProcesoCompletoIT";
import GeneracionDemandaOmnicanal from "./components/incidentes/ProcesoComercialIT/GeneracionDemandaOmnicanal";
import AsignacionCuentasSegmentacionOportunidades from"./components/incidentes/ProcesoComercialIT/AsignacionCuentasSegmentacionOportunidades"
import AnalisisRequerimientos from"./components/incidentes/ProcesoComercialIT/AnalisisRequerimientos"
import DiseñoSolucionPropuestaTecnicoComercial from"./components/incidentes/ProcesoComercialIT/DiseñoSolucionPropuestaTecnicoComercial"
import DiseñoSolucionPropuestaTecnicoComercialRACI from"./components/incidentes/ProcesoComercialIT/DiseñoSolucionPropuestaTecnicoComercialRACI"
import FaseNegociacionCierre from "./components/incidentes/ProcesoComercialIT/FaseNegociacionCierre";


import DocumentosInstitucionales from "./components/incidentes/Operaciones/DocumentosInstitucionales";
import OperacionesGenerales from "./components/incidentes/Operaciones/OperacionesGenerales";
import MesaAyudaCliente from "./components/incidentes/Operaciones/MesaAyudaCliente";
import ImagenCoorporativa from "./components/incidentes/Operaciones/ImagenCoorporativa";
import DescripcionesPuestos from "./components/incidentes/Operaciones/DescripcionesPuestos";
import PuestoPM from "./components/incidentes/Operaciones/PuestoPM";


import ProcesoComercialIngenieria from "./components/incidentes/Ingeniera/ProcesoComercialIngenieria";
import EntregaServicioCliente from "./components/incidentes/Ingeniera/EntregaServicioCliente";
import EntregaServicioClienteRACI from "./components/incidentes/Ingeniera/EntregaServicioClienteRACI";
import SoporteClienteTotal from "./components/incidentes/Ingeniera/SoporteClienteTotal";


import GestionServiciosContratados from "./components/incidentes/Ingeniera/GestionServiciosContratados";
import PolizaEficasia2025 from "./components/incidentes/Ingeniera/PolizaEficasia2025";
import PolizaEficasia2026 from "./components/incidentes/Ingeniera/PolizaEficasia2026";
import PolizaEnestas2025 from "./components/incidentes/Ingeniera/PolizaEnestas2025";
import PolizaComer2025 from "./components/incidentes/Ingeniera/PolizaComer2025";
import PolizaHavas2026 from "./components/incidentes/Ingeniera/PolizaHavas2026";
import PolizaICMyL2025 from "./components/incidentes/Ingeniera/PolizaICMyL2025";
import PolizaICACC2025 from "./components/incidentes/Ingeniera/PolizaICACC2025";
import PolizaMgavilan2025Fw from "./components/incidentes/Ingeniera/PolizaMgavilan2025fw";
import PolizaMgavilan2025Sw from "./components/incidentes/Ingeniera/PolizaMgavilan2025sw";
import PolizaCVeerkamp2026 from "./components/incidentes/Ingeniera/PolizaCVeerkamp2026";
import PolizaIKE2026 from "./components/incidentes/Ingeniera/PolizaIKE2026";


import ProcesosInternos from "./components/incidentes/Ingeniera/ProcesosInternos";
import ProcesosPOC from "./components/incidentes/Ingeniera/ProcesosPOC";
import ProcesosPOCRACI from "./components/incidentes/Ingeniera/ProcesosPOCRACI";
import MantenimientoPreventivo from "./components/incidentes/Ingeniera/MantenimientosPreventivos";
import GuiasTrabajoOnSite from "./components/incidentes/Ingeniera/GuiasTrabajoOnSite";


import RecursosHumanos from "./components/incidentes/AdministracionFinanzas/RecursosHumanos";
import AltaColaboradorProcedimiento from "./components/incidentes/AdministracionFinanzas/AltaColaboradorProcedimiento";
import BajaColaboradorProcedimiento from "./components/incidentes/AdministracionFinanzas/BajaColaboradorProcedimiento";
import SolicitudCamioneta from "./components/incidentes/AdministracionFinanzas/SolicitudCamioneta";
import MantenimientoCorrectivo from "./components/incidentes/Ingeniera/MantenimientosCorrectivos";


import IA from "./components/incidentes/Capacitaciones/ia";
import HistoriaIA from "./components/incidentes/Capacitaciones/historia_ia";
import MachineLearning from "./components/incidentes/Capacitaciones/machine_learning";
import DeepLearning from "./components/incidentes/Capacitaciones/deep_learning";
import IaGenetariva from "./components/incidentes/Capacitaciones/ia_generativa";
import HPC from "./components/incidentes/Capacitaciones/hpc";
import Python from "./components/incidentes/Capacitaciones/python";
import PythonTema1 from "./components/incidentes/Capacitaciones/python-tema1";
import PythonTema2 from "./components/incidentes/Capacitaciones/python-tema2";
import PythonTema3 from "./components/incidentes/Capacitaciones/python-tema3";
import PythonTema4 from "./components/incidentes/Capacitaciones/python-tema4";
import PythonTema5 from "./components/incidentes/Capacitaciones/python-tema5";
import PythonTema6 from "./components/incidentes/Capacitaciones/python-tema6";
import PythonTema7 from "./components/incidentes/Capacitaciones/python-tema7";
import PythonTema8 from "./components/incidentes/Capacitaciones/python-tema8";


import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import Login from "./components/Login";
import Navigation from "./components/Navigation";
import IncidenciasRH from "./components/incidentes/AdministracionFinanzas/incidencias-rh";


function App() {
  const { instance, accounts } = useMsal();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initializeMsal = async () => {
      try {
        await instance.initialize();
        setIsInitialized(true);
      } catch (e) {
        console.log("aqui esta el error...");
        console.error(e);
      }
    };

    initializeMsal();
  }, [instance]);

  const handleLogin = async () => {
    await instance.loginPopup(loginRequest).catch((e) => {
      console.error(e);
    });
  };

  const handleLogout = async () => {
    try {
      await instance.logoutPopup();
    } catch (e) {
      console.error(e);
    }
  };

  const [setGraphData] = useState(null);

  useEffect(() => {
    if (isInitialized && accounts.length > 0) {
      const account = accounts[0];
  
      const fetchData = async () => {
        try {
          const response = await instance.acquireTokenSilent({
            ...loginRequest,
            account,
          });
          const graphResponse = await fetch(
            "https://graph.microsoft.com/v1.0/me",
            {
              headers: {
                Authorization: `Bearer ${response.accessToken}`,
              },
            }
          );
  
          const data = await graphResponse.json();
          setGraphData(data);
        } catch (e) {
          console.error("Error acquiring token or fetching data:", e);
        }
      };
  
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized, accounts, instance]);

  if (!isInitialized) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Spinner animation="border" role="status">
          <span className="sr-only"></span>
        </Spinner>
      </div>
    );
  }

  return (
    <>
      {accounts.length > 0 ? (
        <>
          <Router>
            <Container fluid className="background">
              <Row className="justify-content-center">
                <Navbar bg="light" expand="md" fixed="top">
                  <Navbar.Brand href="/inicio" className="mr-5" style={{ marginLeft: '200px' }}>
                    Intranet Netjer Networks
                  </Navbar.Brand>
                  <Navbar.Toggle aria-controls="basic-navbar-nav" />
                  <Navbar.Collapse id="basic-navbar-nav" style={{ justifyContent: 'center' }}>
                    <Nav className="ml-auto">
                      
                      
                      <NavDropdown 
                        title="Estructura Interna"
                        id="basic-nav-dropdown"
                      >
                        <NavDropdown.Item 
                            as={Link} 
                            to="/organigrama-operacional"
                        >
                          Organigrama Operacional
                        </NavDropdown.Item>

                      
                      </NavDropdown>
                      <NavDropdown 
                        title="Proceso Comercial"
                        id="basic-nav-dropdown"
                      >
                        <NavDropdown.Item 
                          as={Link} 
                          to="/proceso-completo-it"
                        >
                          Proceso Comercial IT
                        </NavDropdown.Item>
                      </NavDropdown>
                      
                      
                      <NavDropdown 
                        title="Operaciones"
                        id="basic-nav-dropdown"
                      >
                        <NavDropdown.Item 
                          as={Link}
                          to="/documentos-institucionales">
                          Documentos Institucionales
                        </NavDropdown.Item>
                        <NavDropdown.Item 
                          as={Link}
                          to="/imagen-coorporativa">
                          Imagen Coorporativa
                        </NavDropdown.Item>
                        <NavDropdown.Item 
                          as={Link}
                          to="/descripciones-puestos">
                          Descripciones de Puestos
                        </NavDropdown.Item>
                      </NavDropdown>
                      

                      <NavDropdown
                        title="Ingeniería"
                        id="basic-nav-dropdown"
                      >
                        <NavDropdown.Item
                          as={Link}
                          to="/proceso-comercial-ingenieria"
                        >
                          Proceso Comercial IT-Ingenería
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to="/procesos-internos"
                        >
                          Procesos Internos
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to="/guias-trabajo-on-site"
                        >
                          Guías Trabajo On Site
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to="/gestion-servicios-contratados"
                        >
                          Gestión de Servicios Contratados
                        </NavDropdown.Item>
                      </NavDropdown>
                      

                      <NavDropdown
                        title="Administración y Finanzas"
                        id="basic-nav-dropdown"
                      >
                        <NavDropdown.Item
                          as={Link} 
                          to="recursos-humanos" 
                        >
                          Recursos Humanos
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to="/marketing"
                          disabled
                        >
                          Marketing
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to="/inventario"
                          disabled
                        >
                          Inventario
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to="/compras"
                          disabled
                        >
                          Compras
                        </NavDropdown.Item>
                      </NavDropdown>
                      
                      
                      <NavDropdown title="Formación" id="basic-nav-dropdown">

                        {/* Submenú IA */}
                        <NavDropdown
                          title="Inteligencia Artificial"
                          id="submenu-ia"
                          drop="end"   // hace que se abra hacia la derecha
                          className="submenu"
                        >
                          <NavDropdown.Item as={Link} to="historia_ia">
                            Historia de la IA
                          </NavDropdown.Item>

                          <NavDropdown.Item as={Link} to="IA">
                            IA
                          </NavDropdown.Item>

                          <NavDropdown.Item as={Link} to="machine_learning">
                            Machine Learning
                          </NavDropdown.Item>

                          <NavDropdown.Item as={Link} to="deep_learning">
                            Deep Learning
                          </NavDropdown.Item>

                          <NavDropdown.Item as={Link} to="ia_generativa">
                            IA Generativa
                          </NavDropdown.Item>
                        </NavDropdown>

                        {/* Submenú HPC */}
                        <NavDropdown
                          title="Cómputo de Alto Desempeño"
                          id="submenu-hpc"
                          drop="end"
                          className="submenu"
                        >
                          <NavDropdown.Item as={Link} to="hpc">
                            HPC
                          </NavDropdown.Item>
                        </NavDropdown>

                        {/* Submenú Python */}
                        <NavDropdown.Item as={Link} to="python" className="submenu">
                          Python
                        </NavDropdown.Item>

                      </NavDropdown>


                      <Nav.Link
                        as="a"
                        href="https://netjernetworks.atlassian.net/servicedesk/customer/portals" // ← reemplaza con tu URL
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: '#000000',
                          fontSize: '16px',
                          fontWeight: 600,
                          textDecoration: 'none',
                          background: 'none',
                          border: 'none',
                        }}                      
                      >
                        Tickets
                      </Nav.Link>


                      <Nav.Item>
                        <Nav.Link className="btn-logout" onClick={handleLogout}>Cerrar sesión</Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Navbar.Collapse>
                </Navbar>
              </Row>
              <Row className="bg-light" id="submenu">
                <Col md={{ offset: 1, span: 10 }}>
                  <p className="navigation">Bienvenido, {accounts[0].name}</p>
                </Col>
                <Col md={{ offset: 1, span: 11 }} className="nav-sections">
                  <Navigation />
                </Col>
              </Row>
            </Container>
            <Container fluid className="main">
              <Routes>
                <Route path="/inicio" element={<Home />} />
                <Route path="/" element={<Home />} />

                <Route
                  path="/organigrama-operacional"
                  element={<OrganigramaOperacional />}
                />
                <Route
                  path="/organigrama-operacional/estructura-operativa"
                  element={<EstructuraOperativa />}
                />


                <Route
                  path="/proceso-completo-it"
                  element={<ProcesoCompleto />}
                />
                <Route
                  path="/proceso-completo-it/proceso-comercial-completo"
                  element={<ProcesoCompletoIT />}
                />
                <Route
                  path="/proceso-completo-it/generacion-demanda-omnicanal"
                  element={<GeneracionDemandaOmnicanal />}
                />
                <Route
                  path="/proceso-completo-it/analisis-requerimientos"
                  element={<AnalisisRequerimientos />}
                />
                <Route
                  path="/proceso-completo-it/asignacion-cuentas-segmentacion-oportunidades"
                  element={<AsignacionCuentasSegmentacionOportunidades />}
                />
                <Route
                  path="/proceso-completo-it/disenio-solucion-propuesta-tecnico-comercial"
                  element={<DiseñoSolucionPropuestaTecnicoComercial />}
                />
                <Route
                  path="/proceso-completo-it/disenio-solucion-propuesta-tecnico-comercial-raci"
                  element={<DiseñoSolucionPropuestaTecnicoComercialRACI />}
                />
                <Route
                  path="/proceso-completo-it/fase-negociacion-cierre"
                  element={<FaseNegociacionCierre />}
                />
                


                <Route
                  path="/documentos-institucionales"
                  element={<DocumentosInstitucionales />}
                />
                <Route
                  path="/documentos-institucionales/operaciones-generales"
                  element={<OperacionesGenerales />}
                />
                <Route
                  path="/documentos-institucionales/mesa-ayuda-cliente"
                  element={<MesaAyudaCliente />}
                />
                <Route
                  path="/imagen-coorporativa"
                  element={<ImagenCoorporativa />}
                />
                <Route
                  path="/descripciones-puestos"
                  element={<DescripcionesPuestos />}
                />
                <Route
                  path="/descripciones-puestos/puesto-pm"
                  element={<PuestoPM />}
                />


                <Route
                  path="/proceso-comercial-ingenieria"
                  element={<ProcesoComercialIngenieria />}
                />
                <Route
                  path="/proceso-comercial-ingenieria/entrega-servicio-cliente"
                  element={<EntregaServicioCliente />}
                />
                <Route
                  path="/proceso-comercial-ingenieria/entrega-servicio-cliente-raci"
                  element={<EntregaServicioClienteRACI />}
                />
                <Route
                  path="/proceso-comercial-ingenieria/soporte-cliente-total"
                  element={<SoporteClienteTotal />}
                />


                <Route
                  path="/procesos-internos"
                  element={<ProcesosInternos />}
                />
                <Route
                  path="/procesos-internos/procesos-poc"
                  element={<ProcesosPOC />}
                />
                <Route
                  path="/procesos-internos/procesos-poc-raci"
                  element={<ProcesosPOCRACI />}
                />
                <Route
                  path="/procesos-internos/mantenimiento-preventivo"
                  element={<MantenimientoPreventivo />}
                />
                <Route
                  path="/procesos-internos/mantenimiento-correctivo"
                  element={<MantenimientoCorrectivo />}
                />



                <Route
                  path="/guias-trabajo-on-site"
                  element={<GuiasTrabajoOnSite />}
                />


                <Route
                  path="/gestion-servicios-contratados"
                  element={<GestionServiciosContratados />}
                />
                <Route
                  path="/gestion-servicios-contratados/eficasia-2025"
                  element={<PolizaEficasia2025 />}
                />
                <Route
                  path="/gestion-servicios-contratados/eficasia-2026"
                  element={<PolizaEficasia2026 />}
                />
                <Route
                  path="/gestion-servicios-contratados/enestas-2025"
                  element={<PolizaEnestas2025 />}
                />
                <Route
                  path="/gestion-servicios-contratados/la-comer-2025"
                  element={<PolizaComer2025 />}
                />
                <Route
                  path="/gestion-servicios-contratados/havas-2026"
                  element={<PolizaHavas2026 />}
                />
                <Route
                  path="/gestion-servicios-contratados/icmyl-2025"
                  element={<PolizaICMyL2025 />}
                />
                <Route
                  path="/gestion-servicios-contratados/icacc-2025"
                  element={<PolizaICACC2025 />}
                />
                <Route
                  path="/gestion-servicios-contratados/mgavilan-2025-sw"
                  element={<PolizaMgavilan2025Sw />}
                />
                <Route
                  path="/gestion-servicios-contratados/mgavilan-2025-fw"
                  element={<PolizaMgavilan2025Fw />}
                />
                <Route
                  path="/gestion-servicios-contratados/cveerkamp-2026"
                  element={<PolizaCVeerkamp2026 />}
                />
                <Route
                  path="/gestion-servicios-contratados/ike-2026"
                  element={<PolizaIKE2026 />}
                />                


                <Route
                  path="/recursos-humanos"
                  element={<RecursosHumanos />}
                />
                <Route
                  path="/recursos-humanos/alta-colaborador-procedimiento"
                  element={<AltaColaboradorProcedimiento />}
                />
                <Route
                  path="/recursos-humanos/baja-colaborador-procedimiento"
                  element={<BajaColaboradorProcedimiento />}
                />
                <Route
                  path="/recursos-humanos/solicitud-camioneta"
                  element={<SolicitudCamioneta />}
                />

                <Route
                  path="/recursos-humanos/incidencias-rh"
                  element={<IncidenciasRH />}
                />



                <Route
                  path="/ia"
                  element={<IA />}
                />

                <Route
                  path="/historia_ia"
                  element={<HistoriaIA />}
                />         
                <Route
                  path="/machine_learning"
                  element={<MachineLearning />}
                />
                <Route
                  path="/deep_learning"
                  element={<DeepLearning />}
                />
                <Route
                  path="/ia_generativa"
                  element={<IaGenetariva />}
                />
                <Route
                  path="/hpc"
                  element={<HPC />}
                />

                <Route
                  path="/python"
                  element={<Python />}
                />
                <Route
                  path="/python/tema-1"
                  element={<PythonTema1 />}
                />
                <Route
                  path="/python/tema-2"
                  element={<PythonTema2 />}
                />
                <Route
                  path="/python/tema-3"
                  element={<PythonTema3 />}
                />
                <Route
                  path="/python/tema-4"
                  element={<PythonTema4 />}
                />
                <Route
                  path="/python/tema-5"
                  element={<PythonTema5 />}
                />
                <Route
                  path="/python/tema-6"
                  element={<PythonTema6 />}
                />
                <Route
                  path="/python/tema-7"
                  element={<PythonTema7 />}
                />
                <Route
                  path="/python/tema-8"
                  element={<PythonTema8 />}
                />

              </Routes>
            </Container>
          </Router>
        </>
      ) : (
        <Login handleLogin={handleLogin} />
      )}
    </>
  );
}
export default App;
